import styled from 'styled-components';

const Text = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular}
  color: ${({ theme }) => theme.colors.night_blue_2};
  margin-left: ${({ theme }) => theme.spacing(3)};
`;

export default Text;
